<template>
  <div class="notificationComp">
    <div class="notificationComp__head">
          <h1 class="mobiTitle md">{{ $t("notification") }}</h1>
    </div>
    <ul>
      <li  v-for="item in notification_g4all" :key="item.key">
        <router-link :to="{name: 'DetailPage',params: { id: item.id }}" class="notificationComp__wrap" >
          <div class="notificationComp__img">
              <img :src="item.thumbnail_url"/>
          </div>
          <div class="notificationComp__content">
            <!-- <h2 class="mobiTitle sm">{{item.content_name}}</h2> -->
            <span v-if="lang_g4all !== 'english'">
              <h2 class="mobiTitle sm" v-if="item[`cont_name_${lang_g4all}`] !== ''">{{ item[`cont_name_${lang_g4all}`] }}</h2>
              <h2 class="mobiTitle sm" v-else>{{ item[`cont_name_english`] }}</h2>
            </span>
            <span v-else>
              <h2 class="mobiTitle sm">{{ item[`cont_name_english`] }}</h2>
            </span>
            <p class="mobilabel">{{ item[`titleSub_${lang_g4all}`] }}</p>
            <!-- <p class="mobilabel">{{item.titleSub_english}}</p> -->
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["notification_g4all", "lang_g4all", "country_g4all"])
  },
  created() {
    this.fetchNotification_g4all();
  },
  methods: {
    ...mapActions(["fetchNotification_g4all"])
  }
};
</script>

<style scoped lang="scss">
.notificationComp {
  background: #fff;
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  ul {
    list-style: none;
    padding: 0;
  }

  a {
    display: flex;
    color: #000;
    text-decoration: none;
    padding: 15px;
  }
  img {
    width: 100%;
  }
}
.notificationComp__head {
  padding: 8px 15px;
}
.notificationComp__content {
  padding-left: 8px;
}
.notificationComp__img {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  overflow: hidden;
}
.ar_layout {
  .notificationComp__content {
    padding-left: 0;
    padding-right: 8px;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/games4all/Notification.vue